import { apiFetch } from "./client";

const fetchSuppliers = async ({ includeArchived = true } = {}) =>
  apiFetch(`/api/suppliers${includeArchived ? "?includeArchived=1" : ""}`);

const toCleanString = (value) => {
  if (value === undefined || value === null) return "";
  return `${value}`.trim();
};

const normalizeContact = (payload = {}) => {
  const contact = payload.contact || {};
  const phone = toCleanString(payload.phone ?? contact.phone);
  const email = toCleanString(payload.email ?? contact.email);

  const result = {};
  if (phone) result.phone = phone;
  if (email) result.email = email;
  return result;
};

const createSupplier = async (payload = {}) => {
  const name = payload?.name?.trim();
  if (!name) {
    throw new Error("Supplier name is required");
  }

  const address = payload?.address?.trim();
  const notes = payload?.notes?.trim();
  const contact = normalizeContact(payload);

  const body = {
    name,
    ...(address ? { address } : {}),
    ...(notes ? { notes } : {}),
    ...(Object.keys(contact).length ? { contact } : {}),
  };

  return apiFetch("/api/suppliers", {
    method: "POST",
    body: JSON.stringify(body),
  });
};

const updateSupplier = async (id, payload = {}) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Supplier id is required");
  }

  const address = payload?.address?.trim();
  const notes = payload?.notes?.trim();
  const contact = normalizeContact(payload);
  const body = {
    ...(payload?.name ? { name: payload.name.trim() } : {}),
    ...(address ? { address } : {}),
    ...(notes ? { notes } : {}),
    ...(Object.keys(contact).length ? { contact } : {}),
  };

  return apiFetch(`/api/suppliers/${normalizedId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
};

const archiveSupplier = async (id) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Supplier id is required");
  }
  return apiFetch(`/api/suppliers/${normalizedId}/archive`, { method: "PATCH" });
};

const restoreSupplier = async (id) => {
  const normalizedId = toCleanString(id);
  if (!normalizedId) {
    throw new Error("Supplier id is required");
  }
  return apiFetch(`/api/suppliers/${normalizedId}/restore`, { method: "PATCH" });
};

export { fetchSuppliers, createSupplier, updateSupplier, archiveSupplier, restoreSupplier };
